import React from 'react';

import { Block } from './Block.jsx';
import { EditorContainer } from '../layout/Builder.jsx';
import { withHoverColorChange } from './Container.jsx';
import {default as mydefaults} from '../layout/Defaults.jsx';
import Kit from '../layout/Kit.jsx';
import { TabSelectionDropDown } from './Tab.jsx';
import Token from './Token.jsx';
import Utilities from './Utilities.jsx';

function _BuilderContainer(props) {
    let blocks = [];
    if (props.contentConfig) {
        blocks.push(props.contentConfig);
    }
    const handleBuilderBlockProps = () => {
        // return { renderControls: false }
        return { content: props.content, hoverProps: props.hoverProps, renderControls: false }
    }
    return (
        <EditorContainer
            {...props}
            blocks={blocks}
            builderBlockPropsHandler={handleBuilderBlockProps}
            className="cell--whitelabel button--whitelabel editor" />
    )
}
const BuilderContainer = withTokenParsing(_BuilderContainer, () => {
    return "Sample Button"
})

function _Content(props) {
    let content;
    if (props.design) {
        const refHover = React.useRef(undefined);
        if (props.hoverProps && props.hoverProps.design) {
            content = (
                <>
                    <span className={`button-content link-default link-active${props.contentClassName ? ` ${props.contentClassName}` : ''}`} dangerouslySetInnerHTML={{ __html: props.design }} style={{ pointerEvents: 'none' }} />
                    <span ref={refHover} className={`button-content link-hover${props.contentClassName ? ` ${props.contentClassName}` : ''}`} dangerouslySetInnerHTML={{ __html: props.hoverProps.design }} style={{ pointerEvents: 'none' }} />
                </>
            )
        } else {
            content = <span className={`button-content${props.contentClassName ? ` ${props.contentClassName}` : ''}`} dangerouslySetInnerHTML={{ __html: props.design }} style={{ pointerEvents: 'none' }} />
        }
        React.useEffect(() => {
            if (!refHover || !refHover.current) {
                return;
            }
            if (Utilities.isHTMLContentEmpty(refHover.current.innerHTML)) {
                refHover.current.className = 'link-hidden';
            }
        }, [refHover]);
    } else {
        content = props.children;
    }
    if (!content) {
        return '';
    }
    return content;
}

function Clickable(props) {
    const handleClick = function (event) {
        if (event) {
            event.preventDefault();
        }
        if (props.onClick) {
            props.onClick(props.id, event);
        }
    }
    const _props = {};
    for (let id in props) {
        switch (id) {
            case 'contentClassName':
            case 'design':
            case 'hoverProps':
                continue;
            default:
                _props[id] = props[id];
                break;
        }
    }
    const content = <_Content {...props} />
    switch (props.type) {
        case 'button':
        case 'submit':
            return <button {..._props} onClick={handleClick}>{content}</button>
        case 'span':
            _props.href = undefined;
            return <span {..._props}>{content}</span>
        default:
            return <a href="#" {..._props} onClick={handleClick}>{content}</a>
    }
}

function ClickableButton(props) {
    return (
        <Clickable type="button" {...props}>
            {props.children}
        </Clickable>
    );
}

const Hoverable = withHoverColorChange(Clickable);

function Link(props) {
    const _props = {};
    for (let id in props) {
        switch (id) {
            case 'contentClassName':
            case 'design':
            case 'hoverProps':
                continue;
            default:
                _props[id] = props[id];
                break;
        }
    }
    const content = <_Content {...props} />
    switch (props.type) {
        case 'span':
            _props.href = undefined;
            return <span {..._props}>{content}</span>
        case 'button':
        case 'submit':
            if (!_props.href || _props.href == '#') {
                return <button {..._props}>{content}</button>
            }
        default:
            if (!_props.style) {
                _props.style = {};
            }
            _props.style.display = 'inline-grid';
            return <a {..._props}>{content}</a>
    }
}
const HoverableLink = withHoverColorChange(Link);

function Wrapper(props) {
    let className = 'btn--wrapper2';
    if (props.wrapperClassName) {
        className += ` ${props.wrapperClassName}`
    }
    const content = (
        <div className={className} style={props.containerStyle}>
            {props.children}
        </div>
    );
    if (props.inLayout) {
        // Flip the order so things render properly in the builder
        return (
            <>
                {content}
                {!props.disabled && props.stateSelectionDropDown}
            </>
        );
    }
    return (
        <>
            {!props.disabled && props.stateSelectionDropDown}
            {content}
        </>
    );
}

function withBlockTypeConfigProps(WrappedComponent, ignoredProps, hasLegacyPadding) {
    return function (props) {
        let _ignoredProps;
        if (ignoredProps) {
            _ignoredProps = new Set(ignoredProps);
        }
        let handleLegacyPadding = true;
        let buttonStyle, display, hoverProps;
        if (props.blockConfig && props.blockConfig.block) {
            buttonStyle = {};
            Block.mapStyleConfigProps(buttonStyle, props.blockConfig.block, (propName, propValue, propUnit) => {
                if (_ignoredProps && _ignoredProps.has(propName)) {
                    return true;
                }
                let _propValue = propValue;
                if (_propValue && propUnit) {
                    _propValue = `${_propValue}${propUnit}`;
                }
                switch (propName) {
                    case 'display':
                        display = _propValue;
                        return true;
                    case 'paddingBottom':
                    case 'paddingLeft':
                    case 'paddingRight':
                    case 'paddingTop':
                        if (propUnit) {
                            handleLegacyPadding = false;
                        }
                        break;
                    default:
                        if (propName.indexOf('Hover') < 0 || !_propValue) {
                            break;
                        }
                        if (!hoverProps) {
                            hoverProps = {};
                        }
                        const _propName = propName.replace('Hover', '');
                        hoverProps[_propName] = _propValue;
                        return true;
                }
            });
        }
        const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, undefined, (propName, propValue, propUnit) => {
            if (_ignoredProps && _ignoredProps.has(propName)) {
                return true;
            }
            if (!handleLegacyPadding || hasLegacyPadding == false) {
                return false;
            }
            switch (propName) {
                case 'paddingBottom':
                case 'paddingLeft':
                case 'paddingRight':
                case 'paddingTop':
                    if (!buttonStyle) {
                        buttonStyle = {};
                    }
                    let _propValue = propValue;
                    if (_propValue && propUnit) {
                        _propValue = `${_propValue}${propUnit}`;
                    }
                    if (_propValue) {
                        buttonStyle[propName] = _propValue;
                    }
                    return true;
            }
        });
        if (props.builder) {
            if (!buttonStyle) {
                buttonStyle = {};
            }
            buttonStyle.pointerEvents = 'none';
        }
        return (
            <div className="btn--wrapper" style={layoutStyles.containerStyle}>
                <WrappedComponent
                    {...props}
                    buttonStyle={buttonStyle}
                    display={display}
                    hoverProps={hoverProps}
                    style={layoutStyles.style}>
                    {props.children}
                </WrappedComponent>
            </div>
        );
    }
}

function withBlockTypeConfigPropsV2(WrappedComponent, ignoredProps, useDesignKitDefaults = false) {
    return function (props) {
        const [id, setId] = React.useState(undefined);
        React.useEffect(() => { setId(Utilities.generateUniqueId()) }, []);

        const [currentState, setCurrentState] = React.useState('default');

        const applyDesignKit = (design, designKit) => {
            if (!design || !designKit || !designKit.typeStyle) {
                return design;
            }
            let testString = '<span';
            const components = design.split('<p');
            let designBlock = '';
            for (let component of components) {
                if (!component) {
                    continue;
                }
                // Remove existing wrapper from component
                let index = component.indexOf(testString);
                if (index < 0) {
                    continue;
                }
                let end = component.lastIndexOf('</p>');
                if (end < 0) {
                    continue;
                }
                let content = component.substring(index, end);
                if (designKit.style) {
                    // Place style from button kit before block style so block style wins
                    content = Utilities.injectStyleIntoString(content, designKit.style, { prepend: true })
                }
                // Wrap content with button kit wrapper
                designBlock += `<p class="${designKit.typeStyle}" style="text-align:${designKit.alignment || 'center'};">${content}</p>`
            }
            return designBlock;
        }

        let _ignoredProps;
        if (ignoredProps) {
            _ignoredProps = new Set(ignoredProps);
        }
        const designKit = {};
        let _currentState = 'default';
        let containerStyle = props.containerStyle && { ...props.containerStyle };
        let buttonStyle, className, designBlock, designHover, hoverProps, percentageWidth;
        if (props.blockConfig) {
            if (props.blockConfig.block) {
                buttonStyle = {};

                // Check for design from button kit
                designKit.blockConfig = Kit.designKit(props.config, props.blockConfig.block.buttonDesign);
                if (!designKit.blockConfig && useDesignKitDefaults && mydefaults.Block[Kit.Type.Button][props.blockConfig.block.buttonDesign]) {
                    designKit.blockConfig = mydefaults.Block[Kit.Type.Button][props.blockConfig.block.buttonDesign]
                }
                if (designKit.blockConfig && designKit.blockConfig.config && designKit.blockConfig.config.block) {
                    Block.mapStyleConfigProps(buttonStyle, designKit.blockConfig.config.block, (propName, propValue) => {
                        switch (propName) {
                            case 'alignment':
                            case 'style':
                            case 'typeStyle':
                                // Store cached design properties from design kit config
                                designKit[propName] = propValue;
                                return true;
                            case 'design':
                                // Ignore the design itself, since the properties are cached during the design phase
                                return true;
                        }
                    });
                }

                // Parse block design (overriding any properties from button kit)
                Block.mapStyleConfigProps(buttonStyle, props.blockConfig.block, (propName, propValue) => {
                    if (_ignoredProps && _ignoredProps.has(propName)) {
                        return true;
                    }
                    switch (propName) {
                        case 'alignment':
                        case 'buttonDesign':
                        case 'style':
                        case 'typeStyle':
                            return true;
                        case 'design':
                            designBlock = propValue;
                            return true;
                    }
                });
            }

            // Check for provided parsed design content
            if (props.builderBlockProps && props.builderBlockProps.content) {
                designBlock = props.builderBlockProps.content;
            } else if (id && !Utilities.isHTMLContentEmpty(props.content)) {
                designBlock = props.content;
            }

            // Apply button kit properties
            designKit.initialDesignBlock = designBlock;
            designBlock = applyDesignKit(designBlock, designKit);

            if (props.blockConfig.hover) {
                if (props.builder && currentState == 'hover') {
                    // Force hover state in builder
                    if (!buttonStyle) {
                        buttonStyle = {};
                    }
                    _currentState = 'hover';
                    className = 'btn--hover';
                }
                if (props.builderBlockProps && props.builderBlockProps.hoverProps) {
                    hoverProps = { ...props.builderBlockProps.hoverProps };
                } else {
                    hoverProps = props.hoverProps ? { ...props.hoverProps } : {};
                }

                // Check for hover design from button kit
                if (designKit.blockConfig && designKit.blockConfig.config && designKit.blockConfig.config.hover) {
                    designKit.hover = {};
                    Block.mapStyleConfigProps(_currentState == 'hover' ? buttonStyle : hoverProps, designKit.blockConfig.config.hover, (propName, propValue) => {
                        if (!id) {
                            return true;
                        }
                        switch (propName) {
                            case 'alignment':
                            case 'style':
                            case 'typeStyle':
                                designKit.hover[propName] = propValue;
                                return true;
                            case 'design':
                                return true;
                        }
                    });
                }

                // Parse block hover design (overriding any properties from button kit)
                Block.mapStyleConfigProps(_currentState == 'hover' ? buttonStyle : hoverProps, props.blockConfig.hover, (propName, propValue) => {
                    if (!id || _ignoredProps && _ignoredProps.has(propName)) {
                        return true;
                    }
                    switch (propName) {
                        case 'alignment':
                        case 'style':
                        case 'typeStyle':
                            return true;
                        case 'design':
                            if (!Utilities.isHTMLContentEmpty(hoverProps.design)) {
                                designHover = hoverProps.design;
                            } else if (!Utilities.isHTMLContentEmpty(propValue)) {
                                designHover = propValue;
                            }
                            return true;
                    }
                });
            }

            // Apply button kit properties
            designHover = applyDesignKit(designHover || designKit.initialDesignBlock, designKit.hover);

            if (props.blockConfig.layout) {
                if (!buttonStyle) {
                    buttonStyle = {};
                }
                const handleLayoutProp = (propName, propValue, propUnit) => {
                    switch (propName) {
                        case 'alignment':
                            buttonStyle.margin = Block.marginForAlignment(propValue);
                            return true;
                        case 'marginBottom':
                        case 'marginLeft':
                        case 'marginRight':
                        case 'marginTop':
                            let _propValue = propValue;
                            if (_propValue && propUnit) {
                                _propValue = `${_propValue}${propUnit}`;
                            }
                            if (_propValue) {
                                if (!containerStyle) {
                                    containerStyle = {};
                                }
                                containerStyle[propName] = _propValue;
                            }
                            return true;
                        case 'width':
                            if (props.inLayout && propValue && propUnit == '%') {
                                // Buttons inside layout containers with percentage width need to be handled differently
                                percentageWidth = `${propValue}${propUnit}`
                                return true;
                            }
                            break;
                    }
                }

                // Check for layout from button kit
                if (designKit.blockConfig && designKit.blockConfig.config && designKit.blockConfig.config.layout) {
                    Block.mapStyleConfigProps(buttonStyle, designKit.blockConfig.config.layout, handleLayoutProp);
                }

                // Parse block layout (overriding any properties from button kit)
                Block.mapStyleConfigProps(buttonStyle, props.blockConfig.layout, (propName, propValue, propUnit) => {
                    if (_ignoredProps && _ignoredProps.has(propName)) {
                        return true;
                    }
                    return handleLayoutProp(propName, propValue, propUnit);
                })
            }
        }
        let design = designBlock;
        if (id) {
            if (!Utilities.isHTMLContentEmpty(designHover)) {
                hoverProps.design = designHover;
                if (_currentState == 'hover') {
                    design = designHover;
                }
            }
        }
        if (percentageWidth) {
            if (!buttonStyle) {
                buttonStyle = {};
            }
            buttonStyle.width = '100%';

            if (!containerStyle) {
                containerStyle = {};
            }
            if (props.builder) {
                // When in builder, buttons inside layout containers with percentage widths apply margins and width to the builder container 
                containerStyle.marginLeft = undefined;
                containerStyle.marginRight = undefined;
                containerStyle.width = '100%';
            } else {
                // Buttons inside layout containers with percentage widths need to apply the width at the top most level so the calculation is correct
                containerStyle.width = percentageWidth;
            }
        }
        let stateSelectionDropDown;
        if (props.builder) {
            if (!buttonStyle) {
                buttonStyle = {};
            }
            buttonStyle.pointerEvents = 'none';

            stateSelectionDropDown = (
                <TabSelectionDropDown
                    label="STATE"
                    tab={currentState}
                    onBlockMove={props.onBlockMove}
                    onSelect={setCurrentState}>
                    <option value={'default'}>Default</option>
                    <option value={'hover'}>Hover</option>
                </TabSelectionDropDown>
            );
        }
        return (
            <WrappedComponent
                {...props}
                className={className}
                containerStyle={containerStyle}
                design={design}
                hoverProps={hoverProps}
                stateSelectionDropDown={stateSelectionDropDown}
                style={buttonStyle}>
                {props.children}
            </WrappedComponent>
        );
    }
}

function withModalVisibility(WrappedComponent) {
    return function (props) {
        let ButtonComponent = Clickable;
        if (props.hoverProps != undefined) {
            ButtonComponent = Hoverable;
        }
        const [modalVisible, setModalVisible] = React.useState(false);
        const handleButtonClick = (_, e) => {
            if (e) {
                e.stopPropagation();
            }
            if (props.onButtonClick) {
                props.onButtonClick(props.data);
            } else {
                setModalVisible(true);
            }
        }
        const handleModalClose = (e) => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }
            setModalVisible(false);
        }
        return (
            <WrappedComponent
                {...props}
                buttonComponent={ButtonComponent}
                modalVisible={modalVisible}
                onButtonClick={handleButtonClick}
                onModalClose={handleModalClose}>
                {props.children}
            </WrappedComponent>
        );
    }
}

function withTokenParsing(WrappedComponent, tokenHandler) {
    return function (props) {
        const data = props.data || {};
        const parseDesignString = (designString) => Token.parseTokenizedString(designString, (keyword) => tokenHandler && tokenHandler(data, keyword) || '');
        const parseContent = function (props) {
            let design;
            if (props.blockConfig && props.blockConfig.block && props.blockConfig.block.design) {
                design = parseDesignString(props.blockConfig.block.design);
            }
            if (Utilities.isHTMLContentEmpty(design)) {
                return '';
            }
            return design;
        }
        const [content, setContent] = React.useState(undefined);
        React.useEffect(() => {
            setContent(parseContent(props));
        }, [props.blockConfig.block.design]);

        const parseHoverContent = function (props) {
            let design;
            if (props.blockConfig && props.blockConfig.hover && props.blockConfig.hover.design) {
                design = parseDesignString(props.blockConfig.hover.design);
            }
            if (Utilities.isHTMLContentEmpty(design)) {
                return '';
            }
            return design;
        }
        const [hoverContent, setHoverContent] = React.useState(undefined);
        React.useEffect(() => {
            setHoverContent(parseHoverContent(props));
        }, [props.blockConfig.hover.design]);

        const hoverProps = props.hoverProps ? { ...props.hoverProps } : {};
        hoverProps.design = hoverContent;
        return (
            <WrappedComponent
                {...props}
                content={content}
                hoverProps={hoverProps}>
                {props.children}
            </WrappedComponent>
        )
    }
}

export {
    BuilderContainer,
    Clickable,
    ClickableButton,
    Hoverable,
    HoverableLink,
    Link,
    Wrapper,
    withBlockTypeConfigProps,
    withBlockTypeConfigPropsV2,
    withModalVisibility,
    withTokenParsing
};